<adapt-collapsible-search-row [result]="result"
                              [matches]="matches"
                              [href$]="href$"
                              [ngClass]="{ 'no-container': !showContainer }">
    <div class="d-flex align-items-center justify-content-center">
        <div class="d-flex flex-grow-0 me-2 align-items-center text-muted">
            @if (result.team) {
                <adapt-link-team [team]="result.team"
                                 [showName]="false"
                                 [showIcon]="true"
                                 [showIconTooltip]="true"></adapt-link-team>
            } @else {
                <div class="d-flex align-items-center result-icon team-icon"
                     adaptTooltip="Team">
                    <i class="fa-inverse fal fa-users"></i>
                </div>
            }
        </div>

        @if (href$ | async; as link) {
            <a [routerLink]="link.path">
                <div class="d-flex align-items-center">
                    <adapt-highlighted-text [needle]="keyword"
                                            [haystack]="result.team.name"></adapt-highlighted-text>
                    @if (showLabels) {
                        <adapt-display-labels class="ms-2 d-inline-block"
                                              [linkDisabled]="true"
                                              [labelLocations]="result.team.labelLocations"></adapt-display-labels>
                    }
                    @if (result.team.isInactive()) {
                        <span class="badge bg-danger"
                              adaptTooltip="This team is no longer active in the organisation."> <i class="fal fa-exclamation-circle"></i>
                            Inactive </span>
                    }
                </div>
            </a>
        }
    </div>
</adapt-collapsible-search-row>
